export interface IWsContacto {
    IdContacto: number;
    IdCliente?: number;
    codCliente: string;
    tipoDocCliente: string;
    numDocCliente: string;
    RazonSocial: string;
    tipoDocumento: string;
    nroDocumento: string;
    nombre: string;
    apePaterno: string;
    apeMaterno: string;    
    direccion: string;
    cargo: string;
    area: string;
    telefono: string;
    anexo: string;
    operador: string;
    numCelular: string;
    email: string;    
    flagActivo?: boolean;
    flagVerificado?: boolean;
    flagCambioPassword?: boolean;
    Password: string;
    fechaRegistro: string;
    fechaModificacion: string;
}

export class WsContacto {
    IdContacto: number;
    IdCliente?: number;
    codCliente: string;
    tipoDocCliente: string;
    numDocCliente: string;
    RazonSocial: string;
    tipoDocumento: string;
    nroDocumento: string;
    nombre: string;
    apePaterno: string;
    apeMaterno: string;    
    direccion: string;
    cargo: string;
    area: string;
    telefono: string;
    anexo: string;
    operador: string;
    numCelular: string;
    email: string;    
    flagActivo?: boolean;
    flagVerificado?: boolean;
    flagCambioPassword?: boolean;
    Password: string;
    fechaRegistro: Date;
    fechaModificacion: Date;

    constructor(data?: IWsContacto) {
        this.flagCambioPassword = false;
        if (data) {
            this.IdContacto = data.IdContacto;
            this.IdCliente = data.IdCliente;
            this.codCliente = data.codCliente;
            this.tipoDocCliente = data.tipoDocCliente;
            this.numDocCliente = data.numDocCliente;
            this.RazonSocial = data.RazonSocial;
            this.tipoDocumento = data.tipoDocumento;
            this.nroDocumento = data.nroDocumento;
            this.nombre = data.nombre;
            this.apePaterno = data.apePaterno;
            this.apeMaterno = data.apeMaterno;
            this.direccion = data.direccion;
            this.cargo = data.cargo;
            this.area = data.area;
            this.telefono = data.telefono;
            this.anexo = data.anexo;
            this.operador = data.operador;
            this.numCelular = data.numCelular;
            this.email = data.email;
            this.flagActivo = data.flagActivo;
            this.flagVerificado = data.flagVerificado;
            this.flagCambioPassword = data.flagCambioPassword ?? false;
            this.Password = data.Password ?? '';
            this.fechaRegistro = data.fechaRegistro ? new Date(data.fechaRegistro) : null;
            this.fechaModificacion = data.fechaModificacion ? new Date(data.fechaModificacion) : null;
        }
    }
}
